import { IPublication } from '../../../../redux/reducers';
import { IPublicationSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';
import { mapPeriod } from './mapPeriod';

export function mapPublication(publication?: IPublicationSchema | null): IPublication {
  const rawPeriod = publication?.period;
  const period = rawPeriod ? mapPeriod(rawPeriod) : null;

  return {
    period,
  };
}
